<template>
    <Title>{{ publicSiteData?.organization_display_name || '' }}</Title>

    <Card v-if="hasWelcomeMessage" class="flex gap-4 mb-12">
        <div class="flex-1">
            <div class="flex gap-2 mb-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.4" d="M2.40039 11.3999C2.40039 13.0911 3.06414 14.6549 4.18914 15.9336C4.11789 16.8524 3.76164 17.6699 3.38664 18.2924C3.18039 18.6374 2.97039 18.9149 2.81664 19.1024C2.73789 19.1961 2.67789 19.2674 2.63289 19.3161C2.61039 19.3386 2.59539 19.3574 2.58414 19.3686L2.57289 19.3799C2.46039 19.4924 2.40039 19.6461 2.40039 19.7999C2.40039 19.8786 2.41539 19.9536 2.44539 20.0286C2.53914 20.2536 2.75664 20.3999 3.00039 20.3999C4.07664 20.3999 5.16039 20.0661 6.06039 19.6761C6.91914 19.3011 7.65039 18.8549 8.09664 18.5286C9.28914 18.9599 10.6091 19.1999 12.0004 19.1999C17.3029 19.1999 21.6004 15.7086 21.6004 11.3999C21.6004 7.0911 17.3029 3.59985 12.0004 3.59985C6.69789 3.59985 2.40039 7.0911 2.40039 11.3999ZM7.20039 8.99985C7.20039 8.3361 7.73664 7.79985 8.40039 7.79985H10.2004C10.8641 7.79985 11.4004 8.3361 11.4004 8.99985V9.89985V10.7999V12.2736C11.4004 13.5936 10.4479 14.7186 9.14289 14.9361L8.84664 14.9849C8.79789 14.9924 8.74539 14.9961 8.69664 14.9961C8.26539 14.9961 7.88289 14.6849 7.81164 14.2424C7.72914 13.7511 8.06289 13.2899 8.55039 13.2074L8.84664 13.1586C9.28164 13.0874 9.60039 12.7124 9.60039 12.2699V11.9961H8.40039C7.73664 11.9961 7.20039 11.4599 7.20039 10.7961V8.9961V8.99985ZM12.6004 8.99985C12.6004 8.3361 13.1366 7.79985 13.8004 7.79985H15.6004C16.2641 7.79985 16.8004 8.3361 16.8004 8.99985V9.89985V10.7999V12.2736C16.8004 13.5936 15.8479 14.7186 14.5429 14.9361L14.2466 14.9849C14.1979 14.9924 14.1454 14.9961 14.0966 14.9961C13.6654 14.9961 13.2829 14.6849 13.2116 14.2424C13.1291 13.7511 13.4629 13.2899 13.9504 13.2074L14.2466 13.1586C14.6816 13.0874 15.0004 12.7124 15.0004 12.2699V11.9961H13.8004C13.1366 11.9961 12.6004 11.4599 12.6004 10.7961V8.9961V8.99985Z" fill="#3658C8"/>
                    <path d="M7.2002 9.00005C7.2002 8.3363 7.73645 7.80005 8.4002 7.80005H10.2002C10.8639 7.80005 11.4002 8.3363 11.4002 9.00005V9.90005V10.8V12.2738C11.4002 13.5938 10.4477 14.7188 9.1427 14.9363L8.84645 14.985C8.3552 15.0675 7.89395 14.7338 7.81145 14.2463C7.72895 13.7588 8.0627 13.2938 8.5502 13.2113L8.84645 13.1625C9.28145 13.0913 9.6002 12.7163 9.6002 12.2738V12H8.4002C7.73645 12 7.2002 11.4638 7.2002 10.8V9.00005ZM16.8002 12.2738C16.8002 13.5938 15.8477 14.7188 14.5427 14.9363L14.2464 14.985C13.7552 15.0675 13.2939 14.7338 13.2114 14.2463C13.1289 13.7588 13.4627 13.2938 13.9502 13.2113L14.2464 13.1625C14.6814 13.0913 15.0002 12.7163 15.0002 12.2738V12H13.8002C13.1364 12 12.6002 11.4638 12.6002 10.8V9.00005C12.6002 8.3363 13.1364 7.80005 13.8002 7.80005H15.6002C16.2639 7.80005 16.8002 8.3363 16.8002 9.00005V9.90005V10.8V12.2738Z" fill="#3658C8"/>
                </svg>
                Welcome message
            </div>
            <div class="text-sm text-gray-700 line-clamp-1 w-full">{{ welcomeMessagePreview }}</div>
        </div>
        <div>
            <Button @click="openWelcomeModal">Read more</Button>
        </div>
    </Card>

    <div class="flex flex-col md:flex-row gap-8">
        <div v-if="publicSiteData?.next_meeting" class="flex-1">
            <Heading3 class="mb-4">Next meeting</Heading3>
            <NextMeetingCard :meeting="publicSiteData.next_meeting"></NextMeetingCard>
        </div>
        <FeaturedMeetingsWidget class="md:w-2/3"></FeaturedMeetingsWidget>
    </div>

    <div class="flex flex-col grid-cols-2 mt-12 gap-x-6 gap-y-4"
         :class="publicSiteData?.has_policies ? 'md:grid' : ''"
    >
        <Heading3>Past meetings</Heading3>
        <Heading3 class="hidden md:block" v-if="publicSiteData?.has_policies">Policies</Heading3>
        <PastMeetingsWidget></PastMeetingsWidget>
        <Heading3 class="md:hidden mt-8" v-if="publicSiteData?.has_policies">Policies</Heading3>
        <PoliciesWidget v-if="publicSiteData?.has_policies"></PoliciesWidget>
    </div>
</template>

<script setup>
import { useModal } from 'vue-final-modal';
import Card from "~/components/public/Card.vue";
import Button from "~/components/public/Button.vue";
import Heading3 from "~/components/public/Heading3.vue";
import PoliciesWidget from "~/components/public/PoliciesWidget.vue";
import NextMeetingCard from "~/components/meetings/NextMeetingCard.vue";
import PastMeetingsWidget from "~/components/public/PastMeetingsWidget.vue";
import WelcomeMessageModal from '~/components/modals/WelcomeMessageModal.vue';
import FeaturedMeetingsWidget from "~/components/public/FeaturedMeetingsWidget.vue";

definePageMeta({layout: 'public-home'});

const publicSiteData = useState('publicSiteData');
const { stripHtml, hasHtmlContent } = useHtmlUtils();

const hasWelcomeMessage = computed(() => {
    return !!publicSiteData.value?.welcome_message && hasHtmlContent(publicSiteData.value.welcome_message);
});

const welcomeMessagePreview = computed(() => {
    if (!publicSiteData.value?.welcome_message) return '';
    return stripHtml(publicSiteData.value.welcome_message);
});

const openWelcomeModal = () => {
    const { open, close } = useModal({
        component: WelcomeMessageModal,
        attrs: {
            welcomeMessage: publicSiteData.value.welcome_message,
            onClose() {
                close();
            }
        }
    });
    open();
};
</script>